// extracted by mini-css-extract-plugin
export default {"mobileCheckoutWrapper":"AfgMY","mobileCheckoutHeader":"nG3ry","mobileCheckoutDivider":"P7YCy"};